import { RejectPromotionModal } from './RejectPromotionModal'
import { withRejectPromotionModal } from './withRejectPromotionModal'

const ConnectedRejectPromotionModal =
  withRejectPromotionModal(RejectPromotionModal)

export { ConnectedRejectPromotionModal as RejectPromotionModal }
